module.exports = __webpack_public_path__ + "static/media/user_management.f97c3003.svg";